import axios from '../../axios'

/*
 * 校考考点信息管理接口
 */

// 创建校考考点信息
export const createXKExamPlace = (data) => {
    return axios({
        url: '/api/data/wish/site',
        method: 'POST',
        data
    })
}

// 获取考点信息详情
export const getExamPlaceInfo = (data) => {
    return axios({
        url: '/api/data/wish/site/info',
        method: 'get',
        data
    })
}

// 修改考点信息
export const editExamPlaceInfo = (data) => {
    return axios({
        url: '/api/data/wish/site',
        method: 'PUT',
        data
    })
}

// 删除考点信息
export const delExamPlaceInfo = (data) => {
    return axios({
        url: '/api/data/wish/site',
        method: 'DELETE',
        data
    })
}

// 获取校考信息列表
export const getExamPlaceList = (data) => {
    return axios({
        url: '/api/data/wish/site',
        method: 'GET',
        data
    })
}

// 关键词模糊搜索
export const searchExamPlaceinfo = (data) => {
    return axios({
        url: '/api/data/wish/search/site',
        method: 'GET',
        data
    })
}

// 根据省份id获取城市信息
export const getCityList = (data) => {
    return axios({
        url: '/api/base/city_list',
        method: 'GET',
        data
    })
}

// 考点信息导入
export const importEPInfo = (data) => {
    return axios({
        url: '/api/data/wish/site/import',
        method: 'POST',
        data
    })
}

// 考点信息导出
export const exportEPInfo = (data) => {
    return axios({
        url: '/api/data/wish/site/export',
        method: 'POST',
        data
    })
}

// 考点信息批量更新
export const updataEPInfo = (data) => {
    return axios({
        url: '/api/data/wish/site/batch/update',
        method: 'POST',
        data
    })
}

// 自定义生成导入模板接口
export const produceTemp = (data) => {
    return axios({
        url: '/api/base/download/excel/template',
        method: 'GET',
        data
    })
}

// 考点信息批量删除
export const queryDelEPInfo = (data) => {
    return axios({
        url: '/api/data/wish/site/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/xkexamplace.js